var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"p-birthday-set-confirm__desc-wrapper\">\n  <p class=\"p-birthday-set-confirm__desc\">ご出産されましたか？</p>\n  <p class=\"p-birthday-set-confirm__sub-desc\">よろしければ、お誕生日ページを表示します</p>\n</div>\n<div class=\"p-birthday-set-confirm__btn-wrapper clearfix\">\n  <button class=\"p-birthday-set-confirm__btn c-popup__btn c-popup__btn--cancel js-birthday-set-confirm-close\">とじる</button>\n  <button class=\"p-birthday-set-confirm__btn c-popup__btn c-popup__btn--submit js-birthday-set-confirm-submit\">産まれました！</button>\n</div>\n";
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/birthday_set_confirm.hbs
// module id = 189
// module chunks = 0 1